import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store/store";
import ContentTypeManagerStyles from "./ContentTypeManagerStyles";
import { useSelector } from "react-redux";
import ContentTypeForm from "../ContentTypeForm/ContentTypeForm";
import ContentTypeList from "../ContentTypeList/ContentTypeList";
import { getContent, getContentTypes } from "../CMSActions";
import ContentList from "../ContentList/ContentList";

interface IProps {
  handleEditClick: (id: string) => void;
}

const ContentTypeManager: React.FC<IProps> = ({ handleEditClick }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const dispatch = useAppDispatch();

  const { calledReducerType } = useAppSelector(
    (state: RootState) => state.common
  );

  const { contentTypes } = useSelector(
    (state: RootState) => state.contentManagement
  );

  const { content } = useSelector(
    (state: RootState) => state.contentManagement
  );

  useEffect(() => {
    dispatch(getContent());
  }, [dispatch, calledReducerType]);

  useEffect(() => {
    dispatch(getContentTypes());
  }, []);

  return (
    <Box 
      sx={ContentTypeManagerStyles?.container}
      id="content_type_manager_container"
      data-test-id="content_type_manager_container"
      aria-label="Content Type Manager"
    >
      <Box 
        sx={ContentTypeManagerStyles?.header}
        id="content_type_manager_header"
        data-test-id="content_type_manager_header"
        aria-label="Content Type Manager Header"
      >
        <Button
          disabled={true}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setIsFormOpen(true)}
          sx={{ borderRadius: "4px" }}
          id="content_type_manager_create_button"
          data-test-id="content_type_manager_create_button"
          aria-label="Create Content Type"
        >
          Create Content Type
        </Button>
      </Box>
      <ContentTypeList contentTypes={contentTypes} content={content} />
      <ContentTypeForm open={isFormOpen} onClose={() => setIsFormOpen(false)} />
      <ContentList content={content} handleEditClick={handleEditClick} />
    </Box>
  );
};

export default ContentTypeManager;
